import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import Button from 'Components/Button/Button';
import InputField from 'Components/Input/InputField';
import LocalTimeFromInstant from 'Components/LocalTimeFromInstant/LocalTimeFromInstant';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';
import MandatoryIconField from 'Components/MandatoryIconField';

const SuspendEmployeeHours = ({
    productionDaysIdSelecteds,
    onUpdateShowSuspendHoursPanel,
    showSuspendEmployeeHoursPanel,
    onUpdateReloadBalanceAllEmployeeHours,
    onUpdateReloadProductionList
}) => {
    const [dtStart, setDtStart] = useState(null)
    const [dtEnd, setDtEnd] = useState(null)
    const [isAction, setIsAction] = useState(null)

    const [recordsEmployeeHours, setRecordsEmployeeHours] = useState(null)
    const [selectsEmployeeHoursRegisters, setSelectsEmployeeHoursRegisters] = useState([])
    const [availableHours, setAvailableHours] = useState('N')

    const attributeList = [
        { name: "id", value: selectsEmployeeHoursRegisters, setter: setSelectsEmployeeHoursRegisters, allowsMultipleRecordsSelected: true },
        { name: "employeeName" },
        { name: "allocatedTime" }
    ];

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    useEffect(() => {
        if (showSuspendEmployeeHoursPanel) {
            resetValues()
        }
    }, [showSuspendEmployeeHoursPanel]);

    useEffect(() => {
        if (availableHours === 'S') {
            setDtStart(null)
            setDtEnd(null)
        }
    }, [availableHours]);

    function resetValues() {
        setSelectsEmployeeHoursRegisters([])
        setIsAction(null)
        setDtEnd(null)
        setDtStart(null)
        setAvailableHours('N')
    }

    useEffect(() => {
        if (!showSuspendEmployeeHoursPanel) {
            return
        }
        reloadEmployeeHoursPanel()
    }, [showSuspendEmployeeHoursPanel]);

    function reloadEmployeeHoursPanel() {
        if (productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1) {
            getEmployeeHoursRecordsGrid(productionDaysIdSelecteds[0])
        } else {
            getEmployeeHoursRecordsGrid(null)
        }
    }

    async function getEmployeeHoursRecordsGrid(productionDaysIdSelecteds) {
        const parameters = {
            productionDayId: productionDaysIdSelecteds ? productionDaysIdSelecteds : 0
        }
        const employeeHoursPanelGrid = await ExecuteAxios.api('get', `/balance-employee/get-list-of-hours-allocated-for-suspension/`, { params: parameters });
        setRecordsEmployeeHours(employeeHoursPanelGrid);
    }

    const closeButtonStyle = {
        width: '85px',
        float: 'right',
        color: 'red',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    const suspendButtonStyle = {
        width: '85px',
        float: 'right',
        color: ((dtStart && dtEnd) || (availableHours)) && isAction
            && selectsEmployeeHoursRegisters && selectsEmployeeHoursRegisters.length > 0 ? 'green' : '#201b2387',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '35px'
    };

    function closeButton() {
        return (
            <Button
                clickMethod={() => { callMethodsClose() }}
                buttonName={'Fechar'}
                style={closeButtonStyle}
            />
        )
    }

    function callMethodsClose() {
        onUpdateShowSuspendHoursPanel(false)
        setRecordsEmployeeHours(null)
        resetValues()
    }

    const detailAtributesStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '33%',
        margin: '1%'
    };

    function suspendEmployeesButton() {
        return (
            <Button
                clickMethod={() => { callToSuspendEmployeesSelected() }}
                buttonName={'Confirmar'}
                style={suspendButtonStyle}
            />
        )
    }

    async function callToSuspendEmployeesSelected() {
        const response = await ExecuteAxios.api('put', `/balance-employee/suspend-or-undo-selected-hour/`, {
            productionDayId: productionDaysIdSelecteds[0],
            startSuspensionDate: LocalTimeFromInstant.getLocalTimeFromInstant(dtStart),
            endSuspensionDate: LocalTimeFromInstant.getLocalTimeFromInstant(dtEnd),
            isAction: isAction,
            availableHours: availableHours,
            selectedEmployeesId: selectsEmployeeHoursRegisters
        });

        if (response) {
            onUpdateReloadBalanceAllEmployeeHours(true);
            onUpdateShowSuspendHoursPanel(false)
        }

        return response;
    }

    function getButtonLeft() {
        return (
            <>
                {suspendEmployeesButton()}
                {closeButton()}
            </>
        )
    }
    function validateDatePickerValue(value, setMethod) {
        if (value instanceof Date && !isNaN(value)) {
            setMethod(value)
        } else {
            setMethod(null)
        }
    }

    const handleCheckboxChangeAvailableHours = (value) => {
        setAvailableHours(value === 'S' ? 'N' : 'S')
    };

    return (
        <MiddlePanel isVisible={showSuspendEmployeeHoursPanel}>
            <Panel style={{
                width: '780px',
                height: '550px',
                padding: '5px',
                borderRadius: '10px',
                backgroundColor: '#f5f5f5',
                border: '1px solid #ccc',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
            }}>
                <LoadingIndicator loaded={recordsEmployeeHours}>
                    <Panel titlePage={'Suspender/Desfazer horas'}
                        style={panelListStyle}
                        canViewCRUD={true}
                        recordsSelected={selectsEmployeeHoursRegisters}
                        componentRightButtons={getButtonLeft()}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', height: '15%' }}>
                                <div style={detailAtributesStyle}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <label>Horário início</label>
                                        <MandatoryIconField />
                                    </div>
                                    <ReactDataPickerComp
                                        selected={dtStart}
                                        onChange={(date) => { validateDatePickerValue(date, setDtStart) }}
                                        wrapperClassName={'width-full'}
                                        className='validate-attribute width-full cursor-pointer'
                                        dateFormat={'HH:mm'}
                                        timeFormat={'HH:mm'}
                                        showTimeSelect={true}
                                        showTimeSelectOnly={true}
                                        setter={setDtStart}
                                        readOnly={availableHours === 'S'}
                                        disabled={availableHours === 'S'}
                                    />
                                </div>
                                <div style={detailAtributesStyle}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <label>Horário fim</label>
                                        {availableHours === 'N' && <MandatoryIconField />}
                                    </div>
                                    <ReactDataPickerComp
                                        selected={dtEnd}
                                        value={dtEnd}
                                        onChange={(date) => { validateDatePickerValue(date, setDtEnd) }}
                                        wrapperClassName={'width-full'}
                                        className='validate-attribute width-full cursor-pointer'
                                        dateFormat={'HH:mm'}
                                        timeFormat={'HH:mm'}
                                        showTimeSelect={true}
                                        showTimeSelectOnly={true}
                                        setter={setDtEnd}
                                        readOnly={availableHours === 'S'}
                                        disabled={availableHours === 'S'}
                                    />
                                </div>

                                <div style={detailAtributesStyle}>
                                    <label>Horários disponíveis</label>
                                    <InputField
                                        setAttribute={() => handleCheckboxChangeAvailableHours(availableHours)}
                                        checked={availableHours === 'S'}
                                        type="checkbox"
                                        style={{ cursor: 'pointer' }}
                                        readOnly={isAction === 'C'}
                                        disabled={isAction === 'C'}
                                    />
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', height: '15%', marginBottom: '15px' }}>
                                <div style={detailAtributesStyle}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <label>Suspender</label>
                                        {!isAction && <MandatoryIconField />}
                                    </div>
                                    <InputField
                                        setAttribute={() => setIsAction('S')}
                                        value={isAction === 'S'}
                                        checked={isAction === 'S'}
                                        type="radio"
                                        style={{ cursor: 'pointer', height: '30px' }}
                                    />
                                </div>
                                <div style={detailAtributesStyle}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <label>Desfazer</label>
                                        {!isAction && <MandatoryIconField />}
                                    </div>
                                    <InputField
                                        setAttribute={() => setIsAction('U')}
                                        value={isAction === 'U'}
                                        checked={isAction === 'U'}
                                        type="radio"
                                        style={{ cursor: 'pointer', height: '30px' }}
                                    />
                                </div>
                                <div style={detailAtributesStyle}>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <label>Limpar marcações</label>
                                        {!isAction && <MandatoryIconField />}
                                    </div>
                                    <InputField
                                        setAttribute={
                                            () => {
                                                setIsAction('C')
                                                setAvailableHours('N')
                                            }
                                        }
                                        value={isAction === 'C'}
                                        checked={isAction === 'C'}
                                        type="radio"
                                        style={{ cursor: 'pointer', height: '30px' }}
                                    />
                                </div>
                            </div>

                            <div style={{ height: '85%' }}>
                                <PanelListDefault
                                    onUpdateIdSelected={setSelectsEmployeeHoursRegisters}
                                    idsSelected={isAction === 'C' ? [] : selectsEmployeeHoursRegisters}
                                    data={recordsEmployeeHours}
                                    attributeList={attributeList}
                                    readOnlyModal={isAction === 'C'}
                                    disableModal={isAction === 'C'}
                                />
                            </div>
                        </div>

                    </Panel>
                </LoadingIndicator>
            </Panel>
        </MiddlePanel >
    );
}

export default SuspendEmployeeHours;
